var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('ul',[_c('li',[_c('router-link',{staticClass:"animate--users",attrs:{"to":"/","title":"Главная"}},[_c('vacancy-icon')],1)],1),(
        _vm.checkAccess('template-field-list', _vm.accessLevel) ||
        _vm.checkAccess('template-directory-list', _vm.accessLevel) ||
        _vm.checkAccess('template-vacancy-list', _vm.accessLevel)
      )?_c('li',[_c('router-link',{staticClass:"animate--notification",attrs:{"to":"/template","title":"Шаблоны"}},[_c('template-icon')],1)],1):_vm._e(),_c('li',[_c('router-link',{staticClass:"animate--setting",attrs:{"to":"/settings","title":"Настройки"}},[_c('setting-icon')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }